import * as React from 'react'
import * as ReactDom from 'react-dom'
import { ResourceProvider } from '../../resourceProvider';
import { Link } from 'react-router-dom';

export interface ISkodaConnectLiteProps {
	Url: string,
	onClick?: () => void
}

export interface ISkodaConnectLiteState {

}

export class SkodaConnectLite extends React.Component<ISkodaConnectLiteProps, ISkodaConnectLiteState>
{
	constructor(props: ISkodaConnectLiteProps) {
		super(props);
	}

	public render(): JSX.Element {
		return (
			<div className="container skoda-connect-lite-container">

				<div className="row tablet d-sm-hidden pl-0 pr-0">
					<div className="skoda-connect-image">
						<table>
							<tbody>
								<tr>
									<td className="align-middle">
										<h4>{ResourceProvider.getText('SkodaConnectLite.Title')}</h4>
										<p className="p4 skoda-connect-text">{ResourceProvider.getText('SkodaConnectLite.Text')}</p>
										<a href={this.props.Url} className="undecorated-link" target="_blank">
											<button className="btn btn-sa-primary btn-availability-primary button-border-radius" onClick={this.props.onClick}>{ResourceProvider.getText('SkodaConnectLite.Link')}</button>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div className="row mobile visible-sm d-md-hidden">
					<div className="skoda-connect-wrapper">
						<div className="skoda-connect-image">
						</div>
						<div>
							<table>
								<tbody>
									<tr>
										<td>
											<h4>{ResourceProvider.getText('SkodaConnectLite.Title')}</h4>
											<p className="p4 skoda-connect-text">{ResourceProvider.getText('SkodaConnectLite.Text')}</p>
											<div>
												<a href={this.props.Url} className="undecorated-link" target="_blank">
													<button className="btn btn-sa-primary btn-availability-primary button-border-radius" onClick={this.props.onClick}>{ResourceProvider.getText('SkodaConnectLite.Link')}</button>
												</a>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

			</div>
		);
	}
}